import { render, staticRenderFns } from "./test-type.vue?vue&type=template&id=12ab344c&scoped=true&"
import script from "./test-type.vue?vue&type=script&lang=js&"
export * from "./test-type.vue?vue&type=script&lang=js&"
import style0 from "./test-type.vue?vue&type=style&index=0&id=12ab344c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab344c",
  null
  
)

export default component.exports